import React from 'react';
import { Spinner } from '@economic/gaudi';
import './style.css';

const Loader = () => {
    const [visible, setVisibility] = React.useState(false);

    React.useEffect(() => {
        const timeout = setTimeout(() => setVisibility(true), 500);
        return () => clearTimeout(timeout);
    }, []);

    return visible ? (
        <div className="flex justify-center loader w-full top-0 absolute left-0 h-full bottom-0 bg-white">
            <Spinner />
        </div>
    ) : null;
};

export default Loader;
